import apiClient from '@/lib/apiClient';
import { API_ENDPOINTS } from '@shared/constants';

export const uhidService = {

  getConnections: async(data: any) => {
    const uahData = {
      uri: '/connections',
      method: 'GET',
      data: {},
    };
    const response = await apiClient.post(API_ENDPOINTS.NODE_API_URI, uahData);
    return response.data;
  },

  // POST /uhid/{id}
  disconnectUhid: async(data?: any) => {
    let localData = {};
    if(data) {
      localData = data;
    }
    const uahData = {
      uri: '/connections',
      method: 'DELETE',
      data: localData,
    };
    const response = await apiClient.post(API_ENDPOINTS.NODE_API_URI, uahData);
    return response.data;
  },
   getConfig: async( data?: any) => {
    const uahData = {
      uri: '/config',
      method: 'GET',
      data: {},
    };
    const response = await apiClient.post(API_ENDPOINTS.NODE_API_URI, uahData);
    return response.data;
  }
};


